import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GenericCrudService } from './generic-crud.service';
const API_URL = environment.prismaApiUrl +'/api/dispo/team_events';

@Injectable({
    providedIn: 'root'
})
export class TeamEventService extends GenericCrudService<Product>{

    constructor(http: HttpClient) {
        super(http, 'api/dispo/team_events');
    }

      getAllByResourceAndDate(object: any): Observable<any> {
        console.log('call GetAllByResourceAndDate');
        return this.http.post<Product>(API_URL + '/get-all-by-resource-and-date', {data: object});
      }

      getAllUndisposedOrders(): Observable<any> {
        return this.http.get(API_URL + '/get-all-undisposed-orders');
      }

      getPrevList(id): Observable<any> {
        return this.http.get(API_URL + '/get-prev-list/' + id);
      }

      //TODO
      meFill(id): Observable<any> {
        return this.http.get(API_URL + '/me-fill/' + id);
      }

      //TODO
      meBlockEvent(id): Observable<any> {
        return this.http.get(API_URL + '/me-block-event/' + id);
      }

      //TODO
      setDefault(id): Observable<any> {
        return this.http.get(API_URL + '/me-set-default/' + id);
      }



}

export interface Product {
    id: number;
    name: string;
    price: number;
    // Weitere Eigenschaften deines Produkts
}

